// @todo use lodash
import deepEqual from 'fast-deep-equal';
export const IkeJson = {
	/**
	 * Attempt to parse a string as JSON
	 * Catching the parse exception
	 *
	 * @returns Resulting JSON, or null if failed to parse
	 */
	parse<T>(s: string): T | null {
		if (s == null) {
			return null;
		}
		try {
			return JSON.parse(s);
		} catch (_e) {
			return null;
		}
	},

	deepEqual(objA, objB): boolean {
		return deepEqual(objA, objB);
	},
};
